<template>
  <div class="camera-box1">
    <div class="camera-box">
      <div class="title1"><span class="title">斗鲸科技</span></div>
<!--      <div class="title1"><span class="title">才萌科技</span></div>-->
      <img src="../assets/camera/service01.png" class="camera-image1" alt="">
      <img src="../assets/camera/service_curr01.png" class="camera-image2" alt="">
      <img src="../assets/camera/service02.png" class="camera-image3" alt="">
      <img src="../assets/camera/service_curr02.png" class="camera-image4" alt="">
      <img src="../assets/camera/service03.png" class="camera-image5" alt="">
      <img src="../assets/camera/service_curr03.png" class="camera-image6" alt="">
      <img src="../assets/camera/service04.png" class="camera-image7" alt="">
      <img src="../assets/camera/service_curr04.png" class="camera-image8" alt="">
      <img src="../assets/camera/service05.png" class="camera-image9" alt="">
      <img src="../assets/camera/service_curr05.png" class="camera-image10" alt="">
      <img src="../assets/camera/service06.png" class="camera-image11" alt="">
      <img src="../assets/camera/service_curr06.png" class="camera-image12" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "camera"
}
</script>

<style scoped>
.camera-box1 {
  position: relative;
  z-index: 10;
  margin-top: -100px;
}

.title1 {
  text-align: center;
  display: block;
  width: 410px;
  height: 420px;
}
.title{
  line-height: 420px;
  font-size: 24px;
  color: #fff;
  font-weight:bold;
}

.camera-box {
  position: relative;
  width: 410px;
  height: 420px;
  margin: 5px auto;
  background: #384047;
  border-radius: 50%;
  animation: rotate 2s linear 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 第一块 */
.camera-image1 {
  position: absolute;
  top: 0;
  left: 110px;
  width: 200px;
  z-index: 1;
}

.camera-image1:hover {
  opacity: 0;
}

.camera-image2 {
  position: absolute;
  width: 200px;
  top: 0;
  left: 110px;
}

/* 第二块 */
.camera-image3 {
  position: absolute;
  top: 35px;
  left: 312px;
  width: 100px;
  z-index: 1;
}

.camera-image3:hover {
  opacity: 0;
}

.camera-image4 {
  position: absolute;
  width: 100px;
  top: 35px;
  left: 312px;
}

/* 第三块 */
.camera-image5 {
  position: absolute;
  top: 225px;
  left: 210px;
  width: 200px;
  z-index: 1;
}

.camera-image5:hover {
  opacity: 0;
  z-index: 2;
}

.camera-image6 {
  position: absolute;
  top: 225px;
  left: 210px;
  width: 200px;
}

/* 第四块 */
.camera-image7 {
  position: absolute;
  top: 278px;
  left: 102px;
  width: 200px;
  z-index: 1;
}

.camera-image7:hover {
  opacity: 0;
}

.camera-image8 {
  position: absolute;
  top: 278px;
  left: 102px;
  width: 200px;
}

/* 第五块 */
.camera-image9 {
  position: absolute;
  top: 147px;
  left: 0px;
  width: 100px;
  z-index: 1;
}

.camera-image9:hover {
  opacity: 0;
}

.camera-image10 {
  position: absolute;
  top: 147px;
  left: 0px;
  width: 100px;;
}

/* 第六块 */
.camera-image11 {
  position: absolute;
  top: 26px;
  left: 0px;
  width: 205px;
  z-index: 1;
}

.camera-image11:hover {
  opacity: 0;
}

.camera-image12 {
  position: absolute;
  top: 26px;
  left: 0px;
  width: 205px;
}

</style>